import React, { useState } from 'react';
// import { useLocation } from 'react-router-dom';
import { Box } from '@chakra-ui/react';
import { useSelector, useDispatch } from 'react-redux';
// import PublicHeader from '../includes/header/PublicHeader';
import PublicMobileHeader from '../includes/header/PublicMobileHeader';
import Sidebar from '../includes/sidebar/Sidebar';
import { SportSelectionProvider } from '../context/SportSelectionContext';
import LoginCard from '../components/login';
import FloatingWhatsApp from '../components/FloatingWhatsApp/FloatingWhatsApp';

const PublicOutlet = (props) => {
  // const location = useLocation();
  const dispatch = useDispatch();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const loginPopOpen = useSelector((state) => state.account.ui.loginPopOpen);

  // const isAuthRoute = ['/login', '/forgot-password', '/loginauth/2'].includes(
  //   location.pathname
  // );

  return (
    <SportSelectionProvider>
      {/* Desktop Header */}
      {/* <Box display={{ base: 'none', md: 'block' }} position="sticky" top="0" zIndex="999">
        <PublicHeader setIsSidebarOpen={setIsSidebarOpen} />
      </Box> */}

      {/* Mobile Header */}
      <Box display={{ base: 'block', md: 'none' }} position="sticky" top="0" zIndex="999">
        <PublicMobileHeader setIsSidebarOpen={setIsSidebarOpen} />
      </Box>

      {isSidebarOpen && (
        <div
          className="sidebar-overlay-clickable"
          onClick={() => setIsSidebarOpen(false)}
          aria-label="Close sidebar"
        />
      )}
      <div className="container-fluid container-fluid-5 snipcss-fJ9mV">
        <div className="row row5 m-0">
          <Sidebar
            isSidebarOpen={isSidebarOpen}
            setIsSidebarOpen={setIsSidebarOpen}
          />
          <Box className="content-box-main">
            <Box className="private-body">{props.children}</Box>
          </Box>
        </div>
      </div>

      {/* Login popup — triggered when non-logged-in user clicks odds or match */}
      {loginPopOpen && (
        <LoginCard onClose={() => dispatch({ type: 'accountData/setLoginPopSate', payload: false })} />
      )}
      <FloatingWhatsApp />
    </SportSelectionProvider>
  );
};

export default PublicOutlet;
